import { CompanyType } from "@/api-schema-enums";
import i18next from "i18next";

export function renderCompanyType(type: CompanyType): string {
  const companyTranslations: Record<CompanyType, string> = {
    Alphartis: i18next.t("masterdata:Alphartis"),
    Transport: i18next.t("masterdata:Transport"),
    Supplier: i18next.t("masterdata:Supplier"),
  };

  return companyTranslations[type] ?? i18next.t("masterdata:UnknownType", { type });
}
